// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Gc-z","heading":"Hc-z"};